import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import { GlobalContext } from '../Contexts/GlobalContext';
import '../Styles/MessageBox.scss';
import CircularProgress from '@material-ui/core/CircularProgress';
import useGuiTranslations from './MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../Util/StringFunctions';


export default function MessageBox() {
    const [translateGui] = useGuiTranslations();
    const globalContext = useContext(GlobalContext);

    const clicked = () => {
        console.log('clickEd!');
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
        if (globalContext.globalState.messageOptions.doSmthIfOk != null) {
            globalContext.globalState.messageOptions.doSmthIfOk();
        }
    }

    const divClicked = () => {
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
    }
    const cancelClick = () => {
        console.log('cancel clicked');
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: '', showButton: false } });
    }

    return (
        <div onClick={divClicked} className="message-box" style={{
            display: globalContext.globalState.messageOptions.message.length != 0 ? 'block' : 'none',
        }}>
            <div className="message-box__inner-wrapper">
                {!globalContext.globalState.messageOptions.showButton ?
                    <CircularProgress></CircularProgress>
                    : null
                }
                {globalContext.globalState.messageOptions.message != '...' ? globalContext.globalState.messageOptions.message : ''}
                <div>
                    {globalContext.globalState.messageOptions.doSmthIfOk != undefined ?
                        <Button  color="primary" style={{ marginTop: '30px', width: '30%', alignSelf: 'flex-end', }} onClick={cancelClick}>
                            {capitalizeFirstLetter(translateGui(44))}
                        </Button>
                        : null
                        }

                    {globalContext.globalState.messageOptions.showButton ?
                        <Button variant="contained" color="primary" style={{ marginTop: '30px', width: '30%', alignSelf: 'flex-end', }} onClick={clicked}>
                            {translateGui(123)}
                        </Button>
                        : null
                        }
                </div>
            </div>
        </div>
    )
}